import { pipe } from 'fp-ts/function';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { maxInputTextLength, presence, TextareaField, validation } from '@mews-commander/legacy-form';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { closeDialog } from '../../../../modules/dialog/reducer';
import { print, PrintFunctionParams, sendToCustomer, showPdf } from '../../Actions/print';

export type PrintActionType = 'print' | 'pdf' | 'send';

export interface FormValues {
    reason?: string;
    type: PrintActionType;
    printParams: PrintFunctionParams;
    pdfUrl: string;
    reloadOnPrint?: boolean;
}

interface DispatchProps {
    onSubmit: (values: FormValues) => void;
    onSubmitSuccess: () => void;
}

const PrintReasonDialogForm = () => (
    <TextareaField label={<LocalizedText textKey={TextKey.PleaseFillInPrintReason} />} name="reason" required />
);

const constraints = {
    reason: {
        presence,
        length: maxInputTextLength,
    },
};

export const formName = 'printReason';

export default pipe(
    PrintReasonDialogForm,
    reduxForm({
        validate: validation(constraints),
        form: formName,
    }),
    connect<{}, DispatchProps, {}, ApplicationState>(null, (dispatch: CommanderThunkDispatch) => ({
        onSubmit: (values) => dispatch(submitPrintReason(values)),
        onSubmitSuccess: () => dispatch(closeDialog(formName)),
    }))
);

export const submitPrintReason =
    ({ reason, type, printParams, pdfUrl, reloadOnPrint }: FormValues) =>
    (dispatch: CommanderThunkDispatch) => {
        if (type === 'print') {
            return dispatch(print({ ...printParams, reason }, pdfUrl, reloadOnPrint));
        } else if (type === 'pdf') {
            return dispatch(showPdf({ ...printParams, reason }, pdfUrl, reloadOnPrint));
        } else if (type === 'send') {
            return dispatch(sendToCustomer(reason, pdfUrl));
        }
    };
